import { CSSObject } from '@chakra-ui/react';

export const FlexPageWrapper: CSSObject = {
  px: '2',
  pb: '5',
  color: 'white',
  bg: 'delta.700',
};
